import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import "vue-multiselect/dist/vue-multiselect.min.css";

import axios, { AxiosError, AxiosResponse } from "axios";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ICountry from "@/interfaces/countries/ICountry";
import { headers } from "@/libs/backend/restAPI/headers";
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";

import Multiselect from "vue-multiselect";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

@Component({
  components: {
    VueCtkDateTimePicker,
    Multiselect,
  },
})
export default class GeneratedLeadReportForm extends Vue {
  @Prop({ type: Object, required: true }) private readonly countries!: {
    loading: boolean;
    list: Readonly<ICountry[]>;
  };

  private infoMessage = "";

  private form: {
    loading: boolean;
    data: {
      dateFrom: string;
      dateTo: string;
      amount: string;
      rewardType: string;
      countries: ICountry[];
      rowsByFile: number;
    };
  } = {
    loading: false,
    data: {
      dateFrom: "",
      dateTo: "",
      amount: "",
      rewardType: "random",
      countries: [],
      rowsByFile: 0,
    },
  };

  private get rewardTypes() {
    return [
      {
        text: "Random",
        value: "random",
      },
      {
        text: "Min for country",
        value: "min_for_country",
      },
      {
        text: "Max for country",
        value: "max_for_country",
      },
    ];
  }

  private get rowsByFile() {
    return [250000, 500000, 750000, 1000000];
  }

  private get validationAmount() {
    return +this.form.data.amount > 0 && +this.form.data.amount % 1 === 0;
  }

  private async generateReport() {
    if (this.form.loading) {
      return;
    }

    this.form.loading = true;

    try {
      const { data } = await axios
        .create({
          headers: headers(),
          baseURL: process.env.VUE_APP_API_HOST,
        })
        .post("/api/main/generated_lead_report_views", {
          ...this.form.data,
          countries: this.form.data.countries.map(({ code }) => code),
          amount: +this.form.data.amount,
          rowsByFile: +this.form.data.rowsByFile,
        });

      const exludeCountries = this.form.data.countries.filter(
        ({ code }) => !data.countries.includes(code)
      );

      if (exludeCountries.length > 0) {
        this.infoMessage = `Следующие страны не вошли в отчёт: ${exludeCountries
          .map(({ name }) => `<b>${name}</b>`)
          .join(", ")}`;
      }

      this.form.loading = false;

      this.$emit("generate", {
        showedInfoMessage: this.infoMessage.length > 0,
      });
    } catch (e) {
      const error = e as AxiosError;
      const response = error.response as
        | AxiosResponse<{
            violations: Array<{ propertyPath: string; title: string }>;
          }>
        | undefined;
      if (
        response &&
        response.data &&
        Array.isArray(response.data.violations)
      ) {
        response.data.violations.forEach(({ propertyPath, title }) => {
          this.$notify({
            group: "notice",
            title: capitalizeFirstLetter(propertyPath),
            text: title,
            type: "error",
          });
        });
      } else {
        this.$notify({
          group: "notice",
          title:
            response && response.status
              ? response.status.toString()
              : undefined,
          text: error.message,
          type: "error",
        });
      }
      this.form.loading = false;
    }
  }

  private mounted() {
    const formatDate = (date: Date) => {
      return date
        .toLocaleString("ru", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .split(".")
        .reverse()
        .join("-");
    };

    this.form.data = {
      dateFrom: formatDate(
        new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      ),
      dateTo: formatDate(new Date()),
      amount: "250000",
      rewardType: "random",
      countries: this.countries.list.concat([]),
      rowsByFile: this.rowsByFile[0],
    };
  }
}
